import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { userInfo as userInfoAction } from '../../reducers/user-info/slice';
import Popover from '../atoms/popover';
import { headerMenuList, menuText } from './navStyle';

//My to do link to use on navbar
const MyToDoLink = ({ linkText = '', userInfo }) => {
  const { actionMessageClosed, userID, apiConfig } = userInfo;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const linkRef = useRef(null);
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [count, setCount] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  useEffect(() => {
    //actionMessageClosed will be false only once when application will be loading
    if (!actionMessageClosed) {
      //To set the anchorEl to linkRef's only when actionMessageClosed is false.
      setAnchorEl(linkRef.current);
      //set isLoading true
      setIsLoading(true);
      //Calling FetchDetailsforActionHome API to get the open action count.
      fetch(`${apiConfig.uiURL}api/FetchDetailsforActionHome`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          userId: userID.toString(),
          RequestURL: '',
        }),
      })
        .then(async response => {
          const data = await response.json();
          setCount(data.ToDoListCount);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkRef, apiConfig]);

  //To close the popover once User Clicks outside of the popover anywhere
  const handleClose = () => {
    setAnchorEl(null);
    dispatch(
      userInfoAction({
        actionMessageClosed: true,
      })
    );
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Link
        ref={linkRef}
        to={{ pathname: '/MyToDo', search: location.search }}
        style={linkText === 'MyToDo' ? headerMenuList : menuText}
      >
        {t('My_to_do_list')}
      </Link>
      <Popover
        count={count}
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        isLoading={isLoading}
      />
    </>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
  };
};

export default connect(mapStateToProps, null)(MyToDoLink);
